import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

import { ConfirmDialogComponent } from '../../dialogs/confirm-dialog/confirm-dialog.component';
import { AutologoutDialogComponent } from '../../dialogs/autologout-dialog/autologout-dialog.component';

@Injectable()
export class DialogService {

  constructor(private dialog: MatDialog) {
  }

  public confirm(message: string, title?: string, input?: boolean): Promise<any> {
    let dialogRef: MatDialogRef<ConfirmDialogComponent>;

    const config: MatDialogConfig = { data: { title: title, message: message, input: input }, autoFocus: false };

    dialogRef = this.dialog.open(ConfirmDialogComponent, config);

    return dialogRef.afterClosed().toPromise();
  }

  public closeAll() {
    this.dialog.closeAll();
  }

  autologout(message: string, title?: string, buttons?) {
    let dialogRef: MatDialogRef<AutologoutDialogComponent>;

    const config: MatDialogConfig = { data: { title: title, message: message, buttons: buttons }, autoFocus: false, width: '600px' };

    dialogRef = this.dialog.open(AutologoutDialogComponent, config);

    return dialogRef.afterClosed().toPromise();
  }

}
